import * as React from 'react'
import {useTranslation} from 'react-i18next'
import '../css/landing.css'
import '../css/monetization.css'
import {ACCENT_TEXT, ACCENT_TEXT_FW500, tagger, setTitleFont} from '../util/util'
import {useEffect} from 'react'

const Security = () => {
    const {t, i18n} = useTranslation('security')
    const activator = (e: any) => e.currentTarget.parentElement.lastChild.classList.toggle('active')

    useEffect(() => {
        setTitleFont(i18n.language)
    }, [])

    return (
        <div className="common-pages-container privacy">
            <p className="title muli">{tagger(t('Personaly Information Security'), ACCENT_TEXT)}</p>
            <div className="text">[Last Updated: 8 May, 2018]</div>
            <div className="text">{tagger(t('is fully committed to provide'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{tagger(t('This information security policy'), ACCENT_TEXT_FW500)}</div>
            <div className="text">{t('technical and organizational safeguards')}</div>
            <div className="accordion" style={{marginTop: '2rem'}}>
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Physical Access Control')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('Personaly ensures the protection'), ACCENT_TEXT_FW500)} <a href="https://aws.amazon.com/security/">https://aws.amazon.com/security/</a>.</p>
                    <p className="text">{tagger(t('Furthermore, some of the'), ACCENT_TEXT_FW500)} <a href="https:/www.digitalocean.com/security/">https:/www.digitalocean.com/security/</a>.</p>
                    <p className="text">{tagger(t('Further, Persona.ly secures'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('System Access Control')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('The access to Persona'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('The systems are protected'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Data Access Control')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('Personaly restricts the access'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('The user password'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('In addition, all of the'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('Further Personaly is'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Organizational and Operational Security')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('Personaly is investing'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Transfer Control')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('The Company does not transfer'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Data Retention')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{t('Personal Data and raw')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Job Control')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('All of Personaly employees'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{tagger(t('In the event of a breach'), ACCENT_TEXT_FW500)}</p>
                    <p className="text">{t('Furthermore the destruction')}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Availability Control')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('The Company has a backup'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
            <div className="accordion">
                <div className="accordion-button" onClick={activator}>
                    <span className="text">{t('Updates')}</span>
                    <img src="https://static.persona.ly/images/dropdown-arrow.svg"/>
                </div>
                <div className="accordion-content">
                    <p className="text">{tagger(t('This Information Security Policy'), ACCENT_TEXT_FW500)}</p>
                </div>
            </div>
        </div>
    )
}

export default Security



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/security.tsx